import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亲密指南',
  url: 'https://climaxpro.github.io',
  description: '以专业、科学和尊重的态度，提供全面的口交知识——从技巧入门到安全防护，从卫生护理到沟通艺术。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://climaxpro.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '亲密指南',
  url: 'https://climaxpro.github.io',
  description: '专注于性健康教育的知识平台，以科学和尊重为基础，传播专业、可靠的性健康知识。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@qinmizhinan.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <Layout>
      <SEOHead
        title="口交完全指南 | 技巧、安全与快感提升 - 亲密指南"
        description="本页围绕口交主题，提供专业、科学、尊重的性健康知识，涵盖口交技巧、安全防护、卫生注意事项及双方沟通要点，帮助成年伴侣在知情同意前提下提升亲密关系质量与性福体验。"
        keywords="口交,口交技巧,口交安全防护,口交卫生注意事项,口交与性健康,成人亲密关系指南,性教育知识"
        canonicalUrl="/"
        ogType="website"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <HeroSection />
      <CategoriesSection />
      <FeaturedArticles />
      <FAQSection />
      <NewsletterSection />
    </Layout>
  );
}